import { create } from "zustand";

export interface DocumentMetadata {
  node_id: string;
  field_id: string;
  field_name?: string;
  field_label?: string;
  [key: string]: unknown; // Allow for additional metadata properties
}

interface DocumentMetadataState {
  documents: DocumentMetadata[];
  setDocuments: (documents: DocumentMetadata[]) => void;
  addDocuments: (documents: DocumentMetadata[]) => void;
  clearDocuments: () => void;
}

export const useDocumentMetadataStore = create<DocumentMetadataState>(
  (set) => ({
    documents: [],

    setDocuments: (documents) => set({ documents }),

    addDocuments: (documents) =>
      set((state) => {
        // Merge with existing documents, avoiding duplicates based on node_id + field_id combination
        const existingKeys = new Set(
          state.documents.map((doc) => `${doc.node_id}-${doc.field_id}`),
        );
        const newDocuments = documents.filter(
          (doc) => !existingKeys.has(`${doc.node_id}-${doc.field_id}`),
        );
        return { documents: [...state.documents, ...newDocuments] };
      }),

    clearDocuments: () => set({ documents: [] }),
  }),
);
